import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Directive } from '@angular/core';
import { NG_VALIDATORS, Validator } from '@angular/forms';

/** Algoritmo de dígito verificador CPF. */
export function cpfValid(value: string): boolean {
  const digits = value.replace(/\D/g, '');
  if (digits.length !== 11) return false;
  if (/^(\d)\1{10}$/.test(digits)) return false;

  let sum = 0;
  for (let i = 0; i < 9; i++) sum += +digits[i] * (10 - i);
  let r = (sum * 10) % 11;
  if (r === 10 || r === 11) r = 0;
  if (r !== +digits[9]) return false;

  sum = 0;
  for (let i = 0; i < 10; i++) sum += +digits[i] * (11 - i);
  r = (sum * 10) % 11;
  if (r === 10 || r === 11) r = 0;
  return r === +digits[10];
}

/** ValidatorFn para uso em Reactive Forms. */
export function cpfValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const v = control.value;
    if (v == null || v === '') return null;
    return cpfValid(String(v)) ? null : { cpf: true };
  };
}

/** Diretiva para uso com ngModel em Template-driven Forms. */
@Directive({
  selector: '[appCpf]',
  standalone: true,
  providers: [{ provide: NG_VALIDATORS, useExisting: CpfValidatorDirective, multi: true }],
})
export class CpfValidatorDirective implements Validator {
  validate(control: AbstractControl): ValidationErrors | null {
    return cpfValidator()(control);
  }
}
